// extracted by mini-css-extract-plugin
export default {"table-listing":"table-listing_table-listing__aZz+p"};